// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_su-0";